// @ts-nocheck
import React, { useEffect, useState } from "react";
import { BlockLoader } from "components/Loaders";
import SidebarLink from "./SidebarLink";
import "../../styles/sidebar.css";
import { useStores } from "hooks/useStores";

const loaders = Array.from({ length: 12 }, (_, index) => (
  <BlockLoader key={index} height={75} className='sidebar-loader' />
));

const Sidebar = () => {
  const [sidebarItems, setSideBarItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { api } = useStores();

  useEffect(() => {
    setLoading(true);
    api.newCatalog.getNomenclatureGroupForSidebar()
      .then((res) => {
        setSideBarItems(res);
      }).finally(() => setLoading(false));
  },[])



  const handleCloseSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    const page = document.querySelector("html");
    const body = document.querySelector("body");
    const header = document.querySelector("#header");
    page.scrollTop = 0;
    if (sidebar.classList.contains("sidebar--show")) {
      sidebar.classList.remove("sidebar--show");
      sidebar.classList.add("sidebar--hide");
      page.style.overflow = "auto";
      body.style.overflow = "auto";
      header.style.paddingRight = "20px";
    }
  };

  return (
    <div className='sidebar'>
      <div className='sidebar-wrapper'>
        <div className='sidebar-title'>Что купить и как выбрать ?</div>
        <div className='sidebar-list'>
          {loading ? loaders : null}

          {!loading
            ? sidebarItems.map((item) => (
                <SidebarLink
                  key={item.id}
                  slug={item.slug}
                  title={item.title}
                  image={item.thumbnail}
                  thumbnailAlt={item.thumbnail_alt}
                  onClick={handleCloseSidebar}
                  bgColor={item.background_color}
                />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
